function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    background-color: #ffffff;\n    box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 3px;\n    z-index: 2;\n\n    .side-nav__list-item {\n        font-size: 16px;\n        font-family: Montserrat;\n        display: block;\n        color: #202834;\n        cursor: pointer;\n        transition: all 0.1s ease-in-out;\n\n        &.active {\n            background-color: ",
        ";\n            color: white;\n        }\n\n        &:hover:not(.active) {\n            background-color: ",
        ";\n        }\n    }\n\n    .side-nav__list-item-text {\n        padding-top: 1rem;\n        padding-bottom: 1rem;\n        padding-right: 18px;\n    }\n\n    .side-nav__list__collapsable {\n        max-height: 0;\n        opacity: 0;\n        transition: all 0.2s ease-in-out;\n\n        .open {\n            max-height: auto;\n            opacity: 1;\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { rgba } from 'polished';
import styled from 'styled-components';
import { BrandingHexColors } from '../GlobalStyle';
export var Container = styled.div(_templateObject(), rgba(BrandingHexColors.BUILDERS_BLUE, 0.75), rgba(BrandingHexColors.BUILDERS_BLUE, 0.2));
